import React from 'react';
import type { ReactElement } from 'react';
import Card from 'atom-components/card';
import AttentionReasons from 'feature-components/mark-response/mark-response-form/fields/attention-reasons';
import Comment from 'feature-components/mark-response/mark-response-form/fields/comment';
import FlagForAttention from 'feature-components/mark-response/mark-response-form/fields/flag-for-attention';
import SaveButtons from 'feature-components/mark-response/mark-response-form/fields/save-buttons';
import type { BaseTag } from 'services/assist-api/entities/tag/tags';
import type { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';
import Reviewer from './reviewer';

type Props = {
  activeReviewerId: number | undefined;
  markStatus: MarkStatus;
  attentionReasons: BaseTag[];
  canEditMark: boolean;
  canAdministrateMark: boolean;
  isSavingOrAllocating: boolean;
};

export default function MarkSubmission({
  activeReviewerId,
  markStatus,
  attentionReasons,
  canEditMark,
  canAdministrateMark,
  isSavingOrAllocating
}: Props): ReactElement {
  return (
    <Card>
      <Card.Header>
        <Card.Heading level={3}>Mark Submission</Card.Heading>
      </Card.Header>
      <Card.Body>
        <Reviewer activeReviewerId={activeReviewerId} markStatus={markStatus} />
        <FlagForAttention canEditMark={canEditMark} />
        <AttentionReasons canEditMark={canEditMark} attentionReasons={attentionReasons} />
        <Comment canEditMark={canEditMark} />
        <SaveButtons
          markStatus={markStatus}
          canEditMark={canEditMark}
          canAdministrateMark={canAdministrateMark}
          isSavingOrAllocating={isSavingOrAllocating}
        />
      </Card.Body>
    </Card>
  );
}
